import { FieldStackedLabel } from '../../../../../Field'
import { FormFieldSelectNG } from '../../../../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../Formik'
import { RequestStatusSelect } from '../../../../RequestStatusSelect'

import * as styles from '../../../ConnectedRequestsMassEditModal.module.css'

function StatusValueField({ label, name, placeholder }) {
  return (
    <FormikField
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={RequestStatusSelect}
      controlProps={{
        contentProps: {
          placeholderProps: {
            text: placeholder,
          },
        },
      }}
      fieldComponentProps={{
        className: styles.valueFieldStackedLabel,
        label,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={name}
    />
  )
}

export default StatusValueField
